<div class="text-center">
    <strong style="font-size: 1.5rem; color: #8E0E00;">Super Users Hub</strong>
</div>

<div class="row mt-2">
    <div class="col-lg-9 col-md-9 col-sm-12 toolbar d-flex align-items-center gap-2">
        <button class="btn btn-success" ngbTooltip="Create users" (click)="createUsers(createUserModal)"
            tooltipClass="custom-tooltip"><span><i class="bi bi-plus me-2"></i></span>Create</button>
        <button class="btn btn-success" (click)="exportToExcel()" ngbTooltip="Export to excel"><span><i
                    class="bi bi-box-arrow-up me-2"></i></span>
            Export</button>
        <!-- <button class="btn btn-success" (click)="printGrid()" ngbTooltip="Print">
            <span><i class="bi bi-printer me-2"></i></span>Print
        </button> -->
        <button class="btn btn-success" (click)="clearGrid()" ngbTooltip="Clear filter"><span> <i
                    class="bi bi-x-circle me-2"></i></span>Clear Filter</button>
    </div>
    <!-- Search -->
    <div class="col-lg-3 col-md-3 m2-3 col-sm-12">
        <input type="text" class="form-control" placeholder="Search" (input)="search($event)" />
    </div>
</div>

<div class="card p-3 mt-3">
    <div class="table-responsive mt-3">
        <table class="table table-bordered table-hover">
            <thead class="table-success">
                <tr>
                    <th class="text-center">Role</th>
                    <th class="text-center">Full Name</th>
                    <th class="text-center">Mobile Number</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">Mapped URL</th>
                    <th class="text-center">Credentials</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of users">
                    <td class="text-center">{{ user.role }}</td>
                    <td class="text-center">{{ user.fullName }}</td>
                    <td class="text-center">{{ user.mobileNumber }}</td>
                    <td class="text-center">{{ user.email }}</td>
                    <td class="text-center"><a [href]="user.mappedUrl" target="_blank">{{ user.mappedUrl }}</a></td>
                    <td class="text-center">
                        <p class="hyperLink">View Credentials</p>
                    </td>
                    <td class="text-center"><span class="badge bg-success">Active</span></td>
                    <td class="text-center">
                        <i class="bi bi-plus-square text-danger" style="cursor: pointer"
                            (click)="editItem(user, createUserModal)"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>



<ng-template #createUserModal let-modal>
    <div class="modal-header custom-modal-header">
        <h3 class="modal-title mt-2">New Configuration</h3>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
        <form [formGroup]="userForm">
            <div class="mb-3">
                <label class="form-label">Select Role</label>
                <select class="form-select" formControlName="role">
                    <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
                </select>
            </div>

            <div class="mb-3">
                <label class="form-label">Enter Full Name</label>
                <input type="text" class="form-control" formControlName="fullName" placeholder="Enter Full Name">
            </div>

            <div class="mb-3">
                <label class="form-label">Enter Mobile Number</label>
                <input type="text" class="form-control" formControlName="mobileNumber"
                    placeholder="Enter Mobile Number">
            </div>

            <div class="mb-3">
                <label class="form-label">Enter Email</label>
                <input type="email" class="form-control" formControlName="email" placeholder="Enter Email">
            </div>

            <div class="mb-3">
                <label class="form-label">Enter Mapped URL</label>
                <input type="text" class="form-control" formControlName="mappedUrl" placeholder="Enter Mapped URL">
            </div>

            <div class="mb-3">
                <label class="form-label">Enter User Name</label>
                <input type="text" class="form-control" formControlName="userName" placeholder="Enter User Name">
            </div>

            <div class="mb-3">
                <label class="form-label">Enter Password</label>
                <input type="password" class="form-control" formControlName="password" placeholder="Enter Password">
            </div>
        </form>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="submitUserForm()">Submit</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    </div>
</ng-template>